import { Button } from "@/components/ui/button"
import { MapPin, Layers } from "lucide-react"

interface BasemapControlsProps {
  currentBasemap: "street" | "satellite"
  onBasemapChange: (basemap: "street" | "satellite") => void
}

/**
 * Component for switching between street and satellite basemaps
 */
export function BasemapControls({ currentBasemap, onBasemapChange }: BasemapControlsProps) {
  return (
    <div className="bg-background/90 backdrop-blur-sm rounded-lg p-2 space-y-1 shadow-lg" style={{ width: 135 }}>
      <Button
        size="sm"
        variant={currentBasemap === "street" ? "default" : "outline"}
        onClick={() => onBasemapChange("street")}
        className="w-full"
      >
        <MapPin className="h-4 w-4 mr-2" />
        Street
      </Button>
      <Button
        size="sm"
        variant={currentBasemap === "satellite" ? "default" : "outline"}
        onClick={() => onBasemapChange("satellite")}
        className="w-full"
      >
        <Layers className="h-4 w-4 mr-2" />
        Satellite
      </Button>
    </div>
  )
}
